import React from "react";
import { PropertyEditorColor, PropertyEditorColorInterface } from "../PropertyEditorColor";
import { StoryNode } from "../../StoryBook/StoryData";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";
import { IDesignValidationProvider, ValidationIssue } from "../../../rule-engine-core/Common/IDesignValidationProvider";

class ColorData implements PropertyEditorColorInterface {
    editObject: { color?: string } = {};
    label: string = "Color Editor";
    name: string = "Color";
    parentDefaultValue: string | null = null;
    propertyName: string = "color";
}

class ColorData2 implements PropertyEditorColorInterface {
    editObject: { color?: string } & IDesignValidationProvider = {
        getDesignValidationIssues(): ValidationIssue[] {
            return [new ValidationIssue("issue", "color"), new ValidationIssue("issue2", "color")];
        },
    };
    label: string = "Color Editor";
    name: string = "Color";
    parentDefaultValue: string | null = null;
    propertyName: string = "color";
}

export const ColorPropertyEditor = [
    new StoryNode(
        (logCallback) => {
            let color = new ColorData();
            return (
                <PropertyEditorColor
                    {...color}
                    onChange={() => logCallback(Reflect.get(color.editObject, color.propertyName))}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Color",
        "Default",
    ),

    new StoryNode(
        (logCallback) => {
            let color = new ColorData();
            color.editObject.color = UIStyleConstants.BLUE_COLOR;
            return (
                <PropertyEditorColor
                    {...color}
                    onChange={() => logCallback(Reflect.get(color.editObject, color.propertyName))}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Color",
        UIStyleConstants.BLUE_COLOR,
    ),

    new StoryNode(
        (logCallback) => {
            let color = new ColorData();
            color.editObject.color = UIStyleConstants.BLUE_COLOR;
            return (
                <PropertyEditorColor
                    {...color}
                    error={"Error Text"}
                    onChange={() => logCallback(Reflect.get(color.editObject, color.propertyName))}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Color",
        "Error",
    ),
    new StoryNode(
        (logCallback) => {
            let color = new ColorData2();
            color.editObject.color = UIStyleConstants.BLUE_COLOR;
            return (
                <PropertyEditorColor
                    {...color}
                    onChange={() => logCallback(Reflect.get(color.editObject, color.propertyName))}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Color",
        "Validation Provider",
    ),
];
